import { useTranslation } from "react-i18next";
import {
  DeleteFilled,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  MoreOutlined,
  SaveOutlined,
  SettingOutlined,
  UploadOutlined
} from "@ant-design/icons";
import { Button, Dropdown, message, Modal, Space, Tooltip, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { deleteCourseSection, publishSection, saveTemplateToLibrary } from "../../../../service/course-construct";
import { globalStore } from "../../../../stores/stores";
import { formatDateV2, formatTimeHm } from "../../../../utils/converDate";
import { handleDownloadMoocsFile } from "../../../../utils/exportMoocsFile";
import AddChapter from "../../../drawer/add-chapter/AddChapter";
import ImportMoocsFile from "../../../import-mooc-file/ImportMoocsFile";
import ChooseLearningMaterialModal from "../../../modal/choose-learning-material/ChooseLearningMaterialModal";
import ActiveSettingsChaptersDrawer from "../../active-settings-chapters-drawer/ActiveSettingsChaptersDrawer";
import "../course-constructor/course-construct.scss";
import "./chapter-card.scss";

type IProp = {
  data?: any;
  handleGetDetail?: any;
};

const ChapterCard = (props: IProp) => {
  const { t } = useTranslation();
  const { reload, setReload } = globalStore()
  const { confirm } = Modal;
  const { data } = props;

  const [cardName, setCardName] = useState(props.data.name);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLesson, setIsLesson] = useState(false);
  const [isSection, setIsSection] = useState(false);
  const [isOpenSettingDraw, setIsOpenSettingDrawer] = useState(false);
  const [isOpenSaveTemplateModal, setIsOpenSaveTemplateModal] = useState(false);
  const params = useParams();
  const tooltipRef = useRef<HTMLDivElement | null>(null);
  const [tooltipWidth, setTooltipWidth] = useState<number>(0);
  const [isOpenImportMoocsFile, setIsOpenImportMoocsFile] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false)

  useEffect(() => {
    setCardName(props.data.name);
  }, [props.data.name])

  const handleDeleteSection = async () => {
    try {
      const response = await deleteCourseSection(Number(props.data.id)).then(
        (result) => {
          props.handleGetDetail();
          message.success(t("Xóa chương học thành công", "Xóa chương học thành công"));
        }
      );
    } catch (error) {
    }
  };

  const showConfirm = () => {
    confirm({
      title: (
        <div className="title-container">
          <div style={{ color: "red", fontSize: "20px" }}>
            <DeleteFilled />
          </div>
          <span>{t("Bạn muốn xóa chương học?", "Bạn muốn xóa chương học?")}</span>
        </div>
      ),
      icon: null,
      okText: t("Xác nhận", "Xác nhận"),
      cancelText: t("Hủy", "Hủy"),
      okType: "danger",
      onOk() {
        handleDeleteSection();
      },
      onCancel() {
      },
    });
  };

  const handlePublishSection = async (sectionId: number) => {
    try {
      await publishSection(sectionId);
      setTimeout(() => {
        setReload(!reload)
      }, 0);
      message.success(t("Xuất bản chương thành công!", "Xuất bản chương thành công!"))
    } catch (err) { }
  }


  const handleSaveTemplate = async (data: any) => {
    setIsSaving(true)
    const payload = {
      id: props.data.id,
      type: "section",
      folderId: data.folderId || undefined
    }

    try {
      await saveTemplateToLibrary(payload)
      message.success(t("Lưu mẫu chương thành công", "Lưu mẫu chương thành công"))
      setTimeout(() => {
        setIsOpenSaveTemplateModal(false)
      }, 0);
    } catch (error) {

    }
    finally {
      setIsSaving(false)
    }
  }

  useEffect(() => {
    if (tooltipRef.current) {
      const width = tooltipRef.current.offsetWidth;
      setTooltipWidth(width);
    }
  }, [cardName]);

  return (
    <>
      <div className="card-heading--info">
        <div className="header--wrapper">
          <div className="header--ctn">
            <div className="header-course">
              <Tooltip title={data?.name}
                overlayStyle={{ maxWidth: tooltipWidth + 20 }}
              >
                <Typography.Title className="text-header-title"
                  ref={tooltipRef}
                  level={5}>{data?.name || ""}</Typography.Title>
              </Tooltip>
              <span className="text-header-description">
                {`
                ${props.data.assignedName ? props.data.assignedName : ""} ${" "} ${props.data.assignedId ? `(${props.data.assignedId})` : ""}
                `}
              </span>
            </div>
            <Space>
              {data?.isPublished ? null :
                <a className="action-course" onClick={() =>
                  Modal.confirm({
                    title: t("Xuất bản chương", "Xuất bản chương"),
                    content: t("Bạn có muốn xuất bản chương này?", "Bạn có muốn xuất bản chương này?"),
                    okText: t("Xác nhận", "Xác nhận"),
                    cancelText: t("Huỷ", "Huỷ"),
                    onOk: () => {
                      handlePublishSection(Number(props.data.id))
                    },
                    onCancel() { },
                  })
                }>
                  <UploadOutlined />
                </a>
              }
              <Dropdown
                menu={{
                  items: [
                    {
                      key: "1",
                      label: t("Sửa chương", "Sửa chương"),
                      icon: <EditOutlined />,
                    },
                    {
                      key: "2",
                      label: t("Xóa chương", "Xóa chương"),
                      icon: <DeleteOutlined />,
                      danger: true,
                    },
                    {
                      key: "3",
                      label: t("Cài đặt hoạt động", "Cài đặt hoạt động"),
                      icon: <SettingOutlined />,
                    },
                    {
                      key: "4",
                      label: t("Lưu mẫu Chương", "Lưu mẫu Chương"),
                      icon: <SaveOutlined />,
                    },
                    {
                      key: "5",
                      label: t("Tải lên bài giảng", "Tải lên bài giảng"),
                      icon: <UploadOutlined />,
                    },
                    {
                      key: "6",
                      label: t("Tải xuống chương", "Tải xuống chương"),
                      icon: <DownloadOutlined />,
                    },
                  ],
                  onClick: ({ key }) => {
                    if (key === "1") {
                      setIsEdit(true);
                      setIsOpenDrawer(true);
                    }
                    if (key === "2") {
                      showConfirm();
                    }
                    if (key === "3") {
                      setIsOpenSettingDrawer(true);
                      setIsSection(true)
                      setIsLesson(false);
                    }
                    if (key === '4') {
                      setIsOpenSaveTemplateModal(true)
                    }
                    if (key === "5") {
                      setIsOpenImportMoocsFile(true);
                    }
                    if (key === '6') {
                      handleDownloadMoocsFile(data?.id, "section", data?.name);
                    }
                  },
                }}
                placement="bottomRight"
              >
                <Button className="action-course">
                  <MoreOutlined />
                </Button>
              </Dropdown>
            </Space>
          </div>
          <div className="text-header-description">
            {t("Lịch trình", "Lịch trình")}{" "}
            {data?.schuduleStartDate && formatDateV2(data?.schuduleStartDate)}
            {data?.schuduleEndDate && '-' + formatDateV2(data?.schuduleEndDate) && '-' + formatDateV2(data?.schuduleEndDate)}
            {data?.schuduleStartDate && ';' + formatTimeHm(data?.schuduleStartDate)}
            {data?.schuduleEndDate && '-' + formatTimeHm(data?.schuduleEndDate)}
          </div>
        </div>
      </div>

      <AddChapter
        id={data.id}
        title="Basic Drawer"
        setIsOpenDrawer={setIsOpenDrawer}
        open={isOpenDrawer}
        handleDetail={props.handleGetDetail}
        itemDetail={props?.data}
        isLesson={isLesson}
        isEdit={isEdit}
        setIsLesson={setIsLesson}
      />
      <ActiveSettingsChaptersDrawer
        id={data.id}
        setIsOpened={setIsOpenSettingDrawer}
        open={isOpenSettingDraw}
        isSection={isSection}
        isLesson={isLesson}
        handleDetail={props.handleGetDetail}
        itemDetail={props?.data}
      />

      {/* <SaveTemplateSequenceModal
        open={isOpenSaveTemplateModal}
        handleClose={() => setIsOpenSaveTemplateModal(false)}
        codeLesson={params?.id}
        sectionId={props?.data?.id}
      /> */}

      <ChooseLearningMaterialModal
        open={isOpenSaveTemplateModal}
        onCancel={() => setIsOpenSaveTemplateModal(false)}
        mode="saveTemplate"
        onSaveTemplate={(data) => {
          handleSaveTemplate(data)
        }}
        isSaving={isSaving}
      />
      <ImportMoocsFile
        parentId={data?.id}
        type="sequence"
        isOpenImportMoocsFile={isOpenImportMoocsFile}
        setIsOpenImportMoocsFile={setIsOpenImportMoocsFile}
      />
    </>
  );
};

export default ChapterCard;